export function sanitizePhoneNumber(phone: string): string {
  let sanitizedPhone = phone ? phone.replace(/\D/g, '') : ''
  if (sanitizedPhone.length > 10 && sanitizedPhone.startsWith('1')) {
    sanitizedPhone = sanitizedPhone.substring(1)
  }
  return sanitizedPhone
}

export function sanitizeEmail(email: string): string {
  return email ? email.trim().toLowerCase() : ''
}

export function sanitizeCode(code: string): string {
  return code ? code.replace(/\D/g, '') : ''
}

export function sanitizeString(input: string): string {
  return input ? input.trim() : ''
}

export function sanitizeDate(input: string): string {
  return input ? input.trim() : ''
}
